import ScrollReveal from '../animations/ScrollReveal';

class Feed extends ScrollReveal {
  constructor(el, initUniqueShapes) {
    super();
    this.$container = $(el);
    this.$anchorLinks = $('.anchor-links .btn');
    this.initUniqueShapes = initUniqueShapes;
    this.init();
  }

  init() {
    this.$container.delegate(
      '.page-numbers',
      'click',
      this.handlePaginationClick.bind(this)
    );

    this.$anchorLinks.on('click', this.handleNavLinksClick.bind(this));
  }

  handleNavLinksClick(e) {
    this.handlePaginationClick(e, true);
  }

  handlePaginationClick(e, isAnchorLink) {
    e.preventDefault();
    const $cur = $(e.currentTarget);
    const href = $cur.attr('href');

    if (isAnchorLink) {
      this.$anchorLinks.removeClass('is-active');
      $cur.addClass('is-active');
    }

    $('html, body').animate(
      { scrollTop: this.$container.offset().top - 200 },
      700
    );

    this.$container.find('.grid-card').removeClass('is-visible');

    this.$container.load(`${href} .feed__inner`, () => {
      const $newItems = this.$container.find('.grid-card');
      this.initUniqueShapes($newItems.find('.media'));
      this.revealTargets($newItems);

      // update url
      window.history.pushState(null, null, href);
    });
  }
}

export default Feed;
